// This will will be extended later on to handle all the logic for the default routes
// For example, if a user has dashboard:view permission, he will see the dashboard on logging in, what if he doesn't have it?
// the default view for the user will be `transactions`. and if he doesn't have the permission to do so also?
// so this will handle all the logic for the redirection logic based on permissions

import { useCurrentUser } from '@/composables/currentUser';
import type {
    NavigationGuardNext,
    RouteLocation,
    RouteLocationNormalized,
    RouteLocationNormalizedLoaded,
} from 'vue-router';

export function redirectToDefaultSettingsView(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: NavigationGuardNext,
) {
    if (isRouteChildOf(to, 'settings')) return next();

    const { hasPermissions } = useCurrentUser();

    if (hasPermissions(['member:write', 'role:write'], 'any')) {
        return redirectToDefaultTeamSettingsView(to, from, next);
    }

    if (hasPermissions('approval-rule:write')) {
        return next({ name: 'approvalRulesTransfers' });
    }

    return next({ name: 'forbidden' });
}

export function redirectToDefaultTeamSettingsView(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: NavigationGuardNext,
) {
    if (isRouteChildOf(to, 'teamSettings')) return next();

    const { hasPermissions } = useCurrentUser();

    if (hasPermissions('member:write')) {
        return next({ name: 'teamMembers' });
    }

    if (hasPermissions('role:write')) {
        return next({ name: 'teamRoles' });
    }

    return next({ name: 'forbidden' });
}

function isRouteChildOf(route: RouteLocation, parentName: string) {
    return (
        route.matched.find((r) => r.name === parentName) &&
        route.name !== parentName
    );
}
